import { render } from "./SmartTok.vue?vue&type=template&id=ff6f9de8&scoped=true"
import script from "./SmartTok.vue?vue&type=script&lang=js"
export * from "./SmartTok.vue?vue&type=script&lang=js"

import "./SmartTok.vue?vue&type=style&index=0&id=ff6f9de8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff6f9de8"]])

export default __exports__